import { Flex, Skeleton } from "antd";

type SkeletonPageProps = {
  type?: "admin-table" | "consumer-page" | "consumer-post-feed" | "consumer-chapter-page";
};

export const SkeletonPage: React.FC<SkeletonPageProps> = ({ type = "admin-table" }) => {
  if (type === "admin-table") {
    return (
      <Flex vertical gap={16}>
        <Flex align="center" gap={16} justify="space-between">
          <Flex align="center" gap={16}>
            <Skeleton.Node style={{ height: 44, width: 485 }} />
            <Skeleton.Node style={{ height: 44, width: 148 }} />
          </Flex>
          <Skeleton.Button style={{ height: 44, width: 96 }} />
        </Flex>

        <Skeleton.Node style={{ height: 440, width: "100%" }} />

        <Flex align="center" justify="space-between" className="pagination-container">
          <Flex align="center" gap={24}>
            <Skeleton.Node style={{ height: 36, width: 65 }} />

            <Flex align="center" gap={8}>
              <Skeleton.Node style={{ height: 36, width: 36 }} />
              <Skeleton.Node style={{ height: 36, width: 36 }} />
            </Flex>
          </Flex>
          <Flex align="center" gap={12}>
            <Skeleton.Node style={{ height: 36, width: 103 }} />
            <Skeleton.Node style={{ height: 36, width: 60 }} />
          </Flex>
        </Flex>
      </Flex>
    );
  }

  if (type === "consumer-page") {
    return (
      <Flex justify="space-between" gap={72}>
        <Flex vertical gap={32} style={{ width: "100%", flexBasis: "60%" }}>
          <Skeleton style={{ height: 20 }} />

          <Flex vertical gap={12} style={{ width: "100%" }}>
            {Array.from({ length: 6 }).map((_, index) => (
              <div key={index} style={{ width: "100%" }}>
                <Skeleton.Node style={{ height: 48, width: "100%" }} />
              </div>
            ))}
          </Flex>
          <Skeleton.Node style={{ width: 163, height: 32 }} />
        </Flex>
        <Flex vertical gap={32} style={{ width: "100%", flexBasis: "40%" }}>
          <Skeleton />
          <Skeleton.Image style={{ height: 280, width: "100%" }} />
          <Skeleton />
        </Flex>
      </Flex>
    );
  }

  if (type === "consumer-post-feed") {
    return (
      <Flex vertical gap={48} style={{ padding: "24px 0" }}>
        <Skeleton style={{ height: 20 }} />

        <Flex vertical gap={32} style={{ width: "60%" }}>
          {Array.from({ length: 4 }).map((_, index) => (
            <Flex key={index} gap={16}>
              <Flex vertical gap={12} style={{ width: "100%" }}>
                <Skeleton.Node style={{ height: 20, width: "60%" }} />
                <Skeleton.Node style={{ height: 16, width: "80%" }} />
                <Skeleton.Node style={{ height: 16, width: "90%" }} />
                <Skeleton.Node style={{ height: 16, width: "70%" }} />
              </Flex>
              <Skeleton.Image style={{ height: 120, width: 120 }} />
            </Flex>
          ))}
        </Flex>
      </Flex>
    );
  }

  if (type === "consumer-chapter-page") {
    return (
      <Flex vertical style={{ padding: "12px 96px" }} align="center">
        <Skeleton />
        <div style={{ width: "100%" }}>
          <Skeleton.Image style={{ width: "100%", height: 130 }} />
        </div>
        <Skeleton />
        <div style={{ width: "100%" }}>
          <Skeleton.Node style={{ width: "100%", height: 130 }} />
        </div>
        <Skeleton />
      </Flex>
    );
  }
};
